export const navigations = [
  {
    path: '/projects',
    icon: 'akar-icons:file',
    label: 'Projects',
    role: 'Customer',
  },
  {
    path: '/reports',
    icon: 'akar-icons:align-bottom',
    label: 'Reports',
    role: 'Customer',
  },
  {
    path: '/formulae',
    icon: 'fluent:math-formula-16-filled',
    label: 'Formulae',
    role: 'Sustainability Architect',
  },
  {
    path: '/carbon-coefficient',
    icon: 'tabler:brand-carbon',
    label: 'Carbon Coefficient',
    role: 'Sustainability Architect',
  },
  {
    path: '/services',
    icon: 'ic:baseline-miscellaneous-services',
    label: 'Services',
    role: 'Sustainability Architect',
  },
  {
    path: '/tags',
    icon: 'uiw:tags-o',
    label: 'Tags',
    role: 'Sustainability Architect',
  },
  {
    path: '/governance',
    icon: 'ri:government-line',
    label: 'Governance',
    role: 'Customer',
  },
  {
    path: '/social',
    icon: 'healthicons:i-groups-perspective-crowd-outline',
    label: 'Social',
    role: 'Customer',
  },
];
